<template>
  <h6>Private Weiterbildung</h6>
  <div class="table-responsive overflow-auto mt-4">
    <table id="dataTable1" class="table table-striped">
      <thead>
      <tr>
        <th>Status</th>
        <th>Maßnahmenart</th>
        <th>JC/AA Nr</th>
        <th>Standort</th>
        <th>Start</th>
        <th>Ende</th>
        <th>Stand</th>
        <th>Stand %</th>
        <th>Letzter Termin</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="coaching in privateLearningCoachingList" :key="coaching.id">
        <td>{{ coaching?.statusTranslation }}</td>
        <td>{{ coaching?.course?.operationTypeTranslation }}</td>
        <td>{{ coaching?.unemployed?.aaNumber }}</td>
        <td>{{ coaching?.unemployed?.location?.name }}</td>
        <td>{{ coaching?.course?.startDate }}</td>
        <td>{{ coaching?.course?.endDate }}</td>
        <td>{{ coaching?.unitsDone }}</td>
        <td>{{ coaching?.unitsDonePercent }} %</td>
        <td>{{ coaching?.lastUnit }}</td>
        <td>
          <a class="btn btn-primary" style="padding: 3px 7px;">
            <i class="bx bx-pencil"></i> Bericht
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  privateLearningCoachingList: {
    require: true,
  },
});
</script>

<style scoped>

</style>